import axios from "axios";

let params = {};

if (process.env.NODE_ENV == "development") {
  params = {
    baseURL: `http://${document.location.hostname}:5000/api`,
  };
} else {
  params = {
    baseURL: `${document.location.origin}/api`,
  };
}

const instance = axios.create(params);

instance.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
instance.interceptors.response.use(
  (response) => response,
  async function (error) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const access_token = await refreshAccessToken();
        axios.defaults.headers.common["authorization"] = access_token;

        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.token = access_token;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));

        return instance(originalRequest);
      } catch (err) {
        // Si el refresh token es inválido o falla, redirigir a logout
        window.location.href = "/logout";
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

async function refreshAccessToken() {
  try {
    const res = await instance.get("v2/user/refresh-token");
    return res.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export default instance;
